import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "q-py-md" }
const _hoisted_2 = {
  key: 0,
  class: "text-h6 q-pb-md q-px-md"
}
const _hoisted_3 = { class: "q-mx-md q-pt-md" }
const _hoisted_4 = { class: "row q-pt-sm" }
const _hoisted_5 = { class: "col-6 q-pr-sm" }
const _hoisted_6 = { class: "col-6 q-pl-sm" }
const _hoisted_7 = { class: "q-pt-md" }
const _hoisted_8 = { class: "q-py-md" }
const _hoisted_9 = { class: "row items-center justify-end" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "q-pt-md" }

import { PropType, ref, watch, onMounted, computed } from "vue";
  import { QInput } from "quasar";

  import { useHideLoading, useLoading, useDialog } from "src/functions";

  import { LoanApplication, Vehicle } from "src/types/loan-application";

  import VehicleLookup from "src/components/form/lookups/VehicleLookup.vue";
  import CurrencyInput from "src/components/form/inputs/CurrencyInput.vue";

  import vehicleService from "src/services/vehicle-service";

  import { useProposalStore } from "src/stores/proposal-store";
  import { useVehicleStore } from "src/stores/vehicle-store";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'VehicleDetailsForm',
  props: {
    modelValue: {
      type: Object as PropType<Vehicle>,
      default: {} as Vehicle
    },
    showTitle: {
      type: Boolean,
      default: true
    }
  },
  emits: [
    'update:modelValue'
  ],
  setup(__props, { expose: __expose, emit: __emit }) {

  const vehicleStore = useVehicleStore();

  const props = __props

  const stock = computed(() => vehicleStore.vehicles);

  const value = computed<Vehicle>({
    get() {
      return props.modelValue
    },
    set(value: Vehicle) {
      emit('update:modelValue', value)
    }
  })

  const emit = __emit

  onMounted(() => {
    if (value.value.make) {
      show.value = true;
      dateString.value = new Date(value.value.vehicleDateOfFirstReg!).toLocaleDateString("en-GB");
      regSearch.value = value.value.vehicleRegistration
    }
  })

  const regSearch = ref("");
  const showDate = ref(false);

  function vehicleFound(vehicle: Vehicle) {
    vehicle.annualMileage = useProposalStore().defaultPcpMileage,
    emit('update:modelValue', vehicle);
    dateString.value = new Date(vehicle.vehicleDateOfFirstReg!).toLocaleDateString("en-GB");
    show.value = true;
  }

  const dateString = ref("");
  watch(dateString, () => {
    if (!dateString.value || dateString.value === '') {
      value.value.vehicleDateOfFirstReg = null;
      return;
    }
    value.value.vehicleDateOfFirstReg = new Date(Number(dateString.value.split("/")[2]), Number(dateString.value.split("/")[1]) - 1, Number(dateString.value.split("/")[0]))
    value.value.regYear = Number(value.value.vehicleDateOfFirstReg.getFullYear().toString().substring(2))
  })

  const show = ref(false);

  const regInput = ref<QInput | null>(null);
  const makeInput = ref<QInput | null>(null);
  const modelInput = ref<QInput | null>(null);
  const yearInput = ref<QInput | null>(null);
  const priceInput = ref<QInput | null>(null);
  const mileageInput = ref<QInput | null>(null);

  __expose({ validate })
  function validate() {
    let valid = true;

    regInput.value!.validate() ? null : valid = false;
    makeInput.value!.validate() ? null : valid = false;
    modelInput.value!.validate() ? null : valid = false;
    yearInput.value!.validate() ? null : valid = false;
    priceInput.value!.validate() ? null : valid = false;
    mileageInput.value!.validate() ? null : valid = false;

    if (!valid) {
      show.value = true;
    }

    return valid;
  }

  const dateRules = computed(() => {
    return [
      (val: string) => !!val || 'Required',
      (val: string) => (val && dateValid(val)) || "Invalid Date",
      (val: string) => (new Date().getFullYear() - new Date(val.split("/").reverse().join("/")).getFullYear() < 15) || "Must be less than 15 years old",
      (val: string) => (new Date() > new Date(val.split("/").reverse().join("/")))|| "Can not be in the future"
    ]
  })


  function dateValid(val: string) {
    const d = new Date(val.split("/").reverse().join("/"))
    return d.toString() !== 'Invalid Date' ? true : false
  }

return (_ctx: any,_cache: any) => {
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.showTitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Vehicle Details "))
      : _createCommentVNode("", true),
    (__props.showTitle)
      ? (_openBlock(), _createBlock(_component_q_separator, { key: 1 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(VehicleLookup, {
        onVehicleFound: vehicleFound,
        placeholder: "Search your stock feed or by VRM",
        vehicles: stock.value
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [
          _createElementVNode("div", { class: "q-pb-xs text-overline text-dark text-uppercase" }, "Vehicle Search", -1)
        ])),
        _: 1,
        __: [9]
      }, 8, ["vehicles"]),
      _createVNode(_component_q_expansion_item, {
        modelValue: show.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((show).value = $event)),
        class: "no-padding hide-toggle"
      }, {
        header: _withCtx(() => _cache[10] || (_cache[10] = [
          _createElementVNode("div", { class: "flex items-center text-body2 text-primary text-underline" }, " Manually enter vehicle details ", -1)
        ])),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "q-pb-xs text-overline text-dark text-uppercase" }, "Make *", -1)),
              _createVNode(_unref(QInput), {
                modelValue: value.value.make,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value.value.make) = $event)),
                ref_key: "makeInput",
                ref: makeInput,
                rules: [val => !!val || 'Required'],
                dense: "",
                "data-cy": "makeInput",
                "data-clarity-mask": "False",
                outlined: ""
              }, null, 8, ["modelValue", "rules"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "q-pb-xs text-overline text-dark text-uppercase" }, "Model *", -1)),
              _createVNode(_unref(QInput), {
                modelValue: value.value.model,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((value.value.model) = $event)),
                ref_key: "modelInput",
                ref: modelInput,
                rules: [val => !!val || 'Required'],
                dense: "",
                "data-cy": "modelInput",
                "data-clarity-mask": "False",
                outlined: ""
              }, null, 8, ["modelValue", "rules"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "q-pb-xs text-overline text-dark text-uppercase" }, "Vehicle Registration *", -1)),
            _createVNode(_unref(QInput), {
              outlined: "",
              dense: "",
              modelValue: value.value.vehicleRegistration,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((value.value.vehicleRegistration) = $event)),
              ref_key: "regInput",
              ref: regInput,
              "data-cy": "regInput",
              "data-clarity-mask": "False",
              rules: [val => !!val || 'Required'],
              class: "text-uppercase"
            }, null, 8, ["modelValue", "rules"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "q-pb-xs text-overline text-dark text-uppercase" }, "Date of Registration* (dd/mm/yyyy) *", -1)),
            _createVNode(_unref(QInput), {
              outlined: "",
              dense: "",
              modelValue: dateString.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dateString).value = $event)),
              ref_key: "yearInput",
              ref: yearInput,
              "data-cy": "regDateInput",
              "data-clarity-mask": "False",
              rules: dateRules.value,
              mask: "##/##/####",
              "lazy-rules": "",
              locale: "en-GB"
            }, {
              append: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "event",
                  size: "xs",
                  class: "cursor-pointer"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_popup_proxy, {
                      cover: "",
                      "transition-show": "scale",
                      "transition-hide": "scale",
                      modelValue: showDate.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showDate).value = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_date, {
                          modelValue: dateString.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dateString).value = $event)),
                          mask: "DD/MM/YYYY"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_9, [
                              _withDirectives(_createVNode(_component_q_btn, {
                                label: "Close",
                                color: "primary",
                                flat: ""
                              }, null, 512), [
                                [_directive_close_popup]
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue", "rules"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(CurrencyInput, {
              modelValue: value.value.price,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((value.value.price) = $event)),
              ref_key: "priceInput",
              ref: priceInput,
              required: ""
            }, {
              default: _withCtx(() => _cache[15] || (_cache[15] = [
                _createElementVNode("div", { class: "q-pb-xs text-overline text-dark text-uppercase" }, "Vehicle Price *", -1)
              ])),
              _: 1,
              __: [15]
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "q-pb-xs text-overline text-dark text-uppercase" }, "Mileage *", -1)),
            _createVNode(_unref(QInput), {
              outlined: "",
              modelValue: value.value.mileage,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((value.value.mileage) = $event)),
              modelModifiers: { number: true },
              ref_key: "mileageInput",
              ref: mileageInput,
              "data-cy": "mileageInput",
              "data-clarity-mask": "False",
              suffix: "miles",
              rules: [val => (val !== null && val !== '') || 'Required', val => (val >= 0) || 'Must be greater than or equal to 0'],
              type: "number",
              "hide-spin-buttons": "",
              min: "0",
              dense: "",
              value: "0"
            }, null, 8, ["modelValue", "rules"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})